export default "__VITE_ASSET__CSRrIdsq__"